import React, { Fragment, useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Text,
  TableContainer,
  Table,
  TableCaption,
  Thead,
  Tr,
  Th,
  Td,
  Input,
} from "@chakra-ui/react";
import useOrder from "./useOrder";
import { Pagination } from "@mui/material";
import "./styles.css"; // Asegúrate de que este archivo tenga los estilos necesarios

const DataTables = ({
  columns,
  dispatchable,
  selectable,
  title = "Lista",
  fire = true,
}) => {
  const dispatch = useDispatch();
  const goDispatch = useRef(dispatchable);

  useEffect(() => {
    goDispatch.current = dispatchable;
  }, [dispatchable]);

  const data = useSelector(selectable);
  const [search, setSearch] = useState("");
  const [rows, setRows] = useState([]);
  const [thead, setThead] = useState([]);
  const [numberPage, setNumberPage] = useState(1);
  const [timer, setTimer] = useState(null);
  const { makeOrder } = useOrder(rows, setRows);

  const searchChanged = (e) => {
    clearTimeout(timer);
    const newTimer = setTimeout(() => {
      setSearch(e.target.value);
    }, 1000);
    setTimer(newTimer);
  };

  useEffect(() => {
    let query = {};
    if (numberPage) query.page = numberPage;
    if (search.trim() !== "") query.s = search.trim();
    fire && dispatch(goDispatch.current(query));
  }, [numberPage, search, fire, dispatch]);

  useEffect(() => {
    if (data?.data !== undefined) {
      const dataMapped = data?.data?.map(columns) || [];
      if (dataMapped.length > 0) {
        const heads = Object.keys(dataMapped[0]).map((key) => ({
          key: key.replaceAll(" ", "_"),
          name: key.toUpperCase().replaceAll("_", " "),
        }));
        setThead(heads);
        setRows(dataMapped);
      }
    }
  }, [data, columns]);

  const handleChange = (_event, value) => {
    setNumberPage(value);
  };

  const renderTable = () => {
    const _rows = rows.map((row, index) => (
      <Tr key={`tbody-tr-${index}`}>
        {thead.map((column) => (
          <Td key={`tbody-tr-td-${column.key}`} color="white">
            {row[column.key]}
          </Td>
        ))}
      </Tr>
    ));

    if (_rows.length < 1) {
      _rows.push(
        <Tr key="no-data">
          <Td colSpan={thead.length} textAlign="center" color="white">
            No hay información disponible
          </Td>
        </Tr>
      );
    }

    return _rows;
  };

  return (
    <Fragment>
      <TableContainer w="100%" h="92%" borderRadius={4} bg="#0d0b12">
        <Text fontSize="lg" fontWeight="bold" p="1rem" color="white">
          {title}
        </Text>

        <div
          className="table-header"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "1rem",
          }}
        >
          <Input
            placeholder="Busca un texto"
            onKeyUp={searchChanged}
            color="white"
            bg="#12100d"
            borderColor="white"
            _placeholder={{ color: "gray.400" }}
          />
          <Pagination
            count={data?.pages || 1}
            page={numberPage}
            onChange={handleChange}
            sx={{ button: { color: "white" } }}
          />
        </div>

        <Table variant="simple" bg="#0d0b12">
          <TableCaption
            color="white"
            borderRadius="12px"
            fontSize="12px"
            fontWeight="500"
          >
            {title}
          </TableCaption>
          <Thead bg="#12100d">
            <Tr>
              {thead.map((column) => (
                <Th
                  key={`thead-tr-${column.key}`}
                  onClick={() => makeOrder(column.key)}
                  color="white"
                  cursor="pointer"
                  _hover={{ textDecoration: "underline" }}
                >
                  {column.name}
                </Th>
              ))}
            </Tr>
          </Thead>
          <tbody>{renderTable()}</tbody>
        </Table>
      </TableContainer>
    </Fragment>
  );
};

export default DataTables;
